import React from 'react';
import { CalendarIcon, TargetIcon, ScaleIcon, UsersIcon, ZapIcon, DollarSignIcon } from 'lucide-react';
export const AIBenefits = () => {
  const benefits = [{
    title: 'AI Strategy in 48h',
    description: 'Get a senior AI leader embedded and delivering a strategic assessment within 48 hours of kickoff.',
    icon: <CalendarIcon className="w-12 h-12 text-white" data-id="element-138" />,
    gradient: 'from-amber-400 to-orange-600'
  }, {
    title: 'Opportunity Mapping',
    description: 'We identify and prioritize the highest-ROI AI opportunities across your product, operations, and growth.',
    icon: <TargetIcon className="w-12 h-12 text-white" data-id="element-139" />,
    gradient: 'from-blue-600 to-green-400'
  }, {
    title: 'Build vs Buy Guidance',
    description: 'Navigate the AI vendor landscape with confidence — model selection, tooling, and infrastructure decisions.',
    icon: <ScaleIcon className="w-12 h-12 text-white" data-id="element-140" />,
    gradient: 'from-orange-500 to-purple-700'
  }, {
    title: 'AI Team Embedded',
    description: 'Your AI lead joins Slack, ships alongside your engineers, and mentors internal talent from day one.',
    icon: <UsersIcon className="w-12 h-12 text-white" data-id="element-141" />,
    gradient: 'from-pink-500 to-green-500'
  }, {
    title: 'Rapid POCs & Evals',
    description: 'Prototype AI features and run rigorous evaluations in weeks — not quarters. Validate before you invest.',
    icon: <ZapIcon className="w-12 h-12 text-white" data-id="element-142" />,
    gradient: 'from-orange-500 to-purple-700'
  }, {
    title: 'Cost-effective Leadership',
    description: 'Get executive-level AI expertise at a fraction of the cost of a full-time Head of AI or VP of AI hire.',
    icon: <DollarSignIcon className="w-12 h-12 text-white" data-id="element-143" />,
    gradient: 'from-red-500 to-blue-600'
  }];
  return <section id="ai-benefits" className="py-20 bg-purple-50 relative overflow-hidden" data-id="element-144">
      <div className="absolute top-0 right-0 w-80 h-80 bg-gradient-to-br from-purple-100 to-purple-50 rounded-full opacity-40 -mr-40 -mt-40" data-id="element-145"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tl from-purple-100 to-purple-50 rounded-full opacity-30 -ml-48 -mb-48" data-id="element-146"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <h2 className="text-3xl md:text-5xl font-bold mb-2 text-black max-w-4xl mx-auto leading-tight" data-id="element-149">
            Why companies choose our Fractional Head of AI
          </h2>
        </div>
        <div className="relative max-w-6xl mx-auto" data-id="element-150">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-151">
            {benefits.map((benefit, index) => <div key={index} className={`rounded-3xl overflow-hidden bg-gradient-to-br ${benefit.gradient} p-8 shadow-lg transform transition-transform hover:scale-105`} data-id="element-152">
                <div className="flex justify-center items-center mb-6" data-id="element-153">
                  <div className="p-4 rounded-full bg-white bg-opacity-20 backdrop-blur-sm shadow-inner" data-id="element-154">
                    {benefit.icon}
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-3 text-white text-center" data-id="element-155">
                  {benefit.title}
                </h3>
                <p className="text-white text-opacity-90 text-center" data-id="element-156">
                  {benefit.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};